// extracted by mini-css-extract-plugin
export default {"dot":"StatusDot_dot__vywdg"};